const layers = {
  heroBackgroundImage: -1,
  base: 0,
  heroBody: 1,
  headerSearch: 2,
  filterInput: 3,
  currencyInput: 4,
  datePicker: 5,
  stickyCTA: 6,
  stickyPrice: 7,
  stickyErrorBar: 8,
  modalOverlay: 9,
  blade: 10,
  secondaryBlade: 11,
} as const;

export default layers;

export type ThemeLayers = typeof layers;
